module.exports = __webpack_public_path__ + "static/media/classResultTemp.25a11900.xlsx";